
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/translate-image-to-english",
      function () {
        return require("private-next-pages/translate-image-to-english/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/translate-image-to-english"])
      });
    }
  